<div class="container h-100">
  <!-- mobile view -->
  <div *ngIf="!error && !loading" class="row row-cols-1">
    <div class="col">
      <div class="row">
        <p>Meine Teilnahme am {{ state?.vertrag?.name }}</p>
      </div>
    </div>
  </div>
  <div class="row row-cols-1 d-md-none">
    <div *ngIf="!error && !loading" class="col">
      <div class="row">
        <label>
          Untenstehend sehen Sie die Daten Ihres behandelnden Arztes
        </label>
      </div>
      <div *ngIf="state?.arzt?.praxis_name" class="form-group">
        <label class="small">Name der Institution</label>
        <div>{{ state?.arzt?.praxis_name }}</div>
      </div>
      <div class="form-group">
        <label class="small">LANR / BSNR</label>
        <div>{{ state?.arzt?.lanr }} / {{ state?.arzt?.bsnr }}</div>
      </div>
      <div class="form-group">
        <label class="small">Behandelnder Arzt</label>
        <div class="font-weight-bold">
          {{ state?.arzt?.anrede_titel_nachname }}
        </div>
      </div>
      <div class="form-group">
        <label class="small">Anschrift</label>
        <div class="font-weight-bold">{{ state?.arzt?.adresse }}</div>
      </div>
    </div>
    <div *ngIf="error && !loading" class="col">
      Die Arztdaten können nicht geladen werden. Bitte versuchen Sie es später
      erneut oder nehmen Sie Kontakt mit dem Service auf.
    </div>
  </div>
  <!-- desktop view -->
  <div class="row row-cols-1 d-none d-md-block">
    <div *ngIf="!error && !loading" class="col">
      <table class="table table-borderless data-table table-sm">
        <tr>
          <td>Untenstehend sehen Sie die Daten Ihres behandelnden Arztes</td>
        </tr>
        <tr>
          <td colspan="2">
            <hr class="my-0"/>
          </td>
        </tr>
        <tr *ngIf="state?.arzt?.praxis_name">
          <td>Name des Institutes</td>
          <td>{{ state?.arzt?.praxis_name }}</td>
        </tr>
        <tr>
          <td>LANR / BSNR</td>
          <td>{{ state?.arzt?.lanr }} / {{ state?.arzt?.bsnr }}</td>
        </tr>
        <tr>
          <td>Behandelnder Arzt</td>
          <td class="font-weight-bold">
            {{ state?.arzt?.anrede_titel_nachname }}
          </td>
        </tr>
        <tr>
          <td>Anschrift</td>
          <td class="font-weight-bold">{{ state?.arzt?.adresse }}</td>
        </tr>
        <tr>
          <td colspan="2">
            <hr class="my-0"/>
          </td>
        </tr>
      </table>
    </div>
    <div *ngIf="error && !loading" class="col">
      Die Arztdaten können nicht geladen werden. Bitte versuchen Sie es später
      erneut oder nehmen Sie Kontakt mit dem Service auf.
    </div>
  </div>
  <!-- both -->
  <div *ngIf="loading" class="text-center">
    <fa-icon [icon]="spinnerIcon" animation="spin-pulse"></fa-icon>
  </div>
  <div *ngIf="!error && !loading" class="text-center">
    <button
      #btnWeiter
      (click)="onWeiterClicked()"
      [disabled]="sending"
      class="btn btn-primary"
    >
      Bestätigen<span *ngIf="sending"
    >&nbsp;<fa-icon [icon]="spinnerIcon" animation="spin-pulse"></fa-icon
    ></span>
    </button>
  </div>
</div>
